/**
 * "What makes it different" auto-advance. Figma 631:1953 — the drawn 305px
 * teal segment on the open row's rule is a snapshot of a running timer.
 *
 * The fill itself is a CSS animation on the open row's summary::after
 * (pdp-feature-list.liquid); this element only does what CSS cannot:
 *   - opens the NEXT row when the fill animation finishes,
 *   - gates the animation on visibility (`.is-in-view`), so the timer does
 *     not run while the section is off screen.
 *
 * Manual clicks need no code: <details name> keeps one row open natively,
 * and the newly opened row's [open] match starts a fresh fill. With reduced
 * motion the animation never runs, so no advance ever fires — the section
 * behaves like the static design.
 */
(() => {
  'use strict';

  class PdpFeatures extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('.pdp-features__row'));
      if (this.rows.length < 2 || !this.classList.contains('pdp-features--autoplay')) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => this.classList.toggle('is-in-view', entry.isIntersecting));
        },
        { threshold: 0.35 }
      );
      this.observer.observe(this);

      // animationend fires on the summary that owns the ::after.
      this.addEventListener('animationend', (event) => {
        if (event.animationName !== 'pdp-features-fill') return;
        const openIndex = this.rows.findIndex((row) => row.open);
        const next = this.rows[(openIndex + 1) % this.rows.length];
        if (next) next.open = true; // the name group closes the current row
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('pdp-features')) customElements.define('pdp-features', PdpFeatures);
})();
